import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { LogService } from '../../../services/log.service';

@Component({
  selector: 'app-edit-type',
  templateUrl: './edit-type.component.html',
  styleUrls: ['./edit-type.component.scss']
})
export class EditTypeComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private mDatabase: AngularFireDatabase,
    private mLogService: LogService,
    public dialogRef: MatDialogRef<EditTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { key: string; name: string; selectedType: string }
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl(this.data.name, Validators.required)
    });
  }

  get Name() {
    return this.form.get('name');
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const newName = this.form.get('name')?.value;
    this.mDatabase
      .object('types/' + this.data.selectedType + '/' + this.data.key)
      .set(newName)
      .then(() => {
        this.mLogService.addLog({
          date: new Date().getTime(),
          section: 'Types',
          action: 'Edit',
          description: `Types Edit ${this.data.selectedType} value from "${this.data.name}" to "${newName}" by user`,
          currentIp: localStorage.getItem('currentip')!
        });
        this.dialogRef.close();
      });
  }
}